export default {
    password : 'Passwords must be at least six characters and match the confirmation.',
    reset : 'Your password has been reset!',
    match: 'Passwords do not match!',
    sent : 'We have e-mailed your password reset link!',
    token : 'This password reset token is invalid.',
    user : "We cant find a user with that e-mail address.",
    wrong: 'Password or email is incorrect'
}